var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { parse, serialize } from 'toad-uri-js';
import { invariant } from '../util/invariant';
function updateQuery(query, updatedQuery) {
    const result = new URLSearchParams(query);
    const params = new URLSearchParams(updatedQuery);
    params.forEach((value, key) => result.set(key, value));
    return result.toString();
}
function updateURL(url, updatedURL) {
    const result = Object.assign({}, url, updatedURL);
    if (url.query && updatedURL.query) {
        result.query = updateQuery(url.query, updatedURL.query);
    }
    if (url.parameters && updatedURL.parameters) {
        result.parameters = Object.assign({}, url.parameters, updatedURL.parameters);
    }
    return result;
}
function updateHeaders(headers, updatedHeaders) {
    const result = new Headers(headers);
    const updatedHeadersObject = new Headers(updatedHeaders);
    updatedHeadersObject.forEach((value, key) => result.set(key, value));
    return result;
}
function updateResourceConfiguration(configuration, updatedConfiguration) {
    const result = Object.assign({}, configuration, updatedConfiguration);
    return result;
}
export function updateRequest(request, updatedRequest) {
    const result = Object.assign({}, request);
    for (const [key, value] of Object.entries(updatedRequest)) {
        if (value === null) {
            delete result[key];
        }
        else if (value !== undefined) {
            result[key] = value;
        }
    }
    if (request.url && updatedRequest.url) {
        result.url = updateURL(request.url, updatedRequest.url);
    }
    if (request.headers && updatedRequest.headers) {
        result.headers = updateHeaders(request.headers, updatedRequest.headers);
    }
    if (request.resourceConfiguration && updatedRequest.resourceConfiguration) {
        result.resourceConfiguration = updateResourceConfiguration(request.resourceConfiguration, updatedRequest.resourceConfiguration);
    }
    return result;
}
// TODO: make Expression from @criteria/predicates
export function evaluatePath(expression, parameters) {
    var _a, _b;
    let result = '';
    let i = 0;
    const matches = expression.matchAll(/\{([^}]*)\}/g);
    for (const match of matches) {
        const parameterName = match[1];
        result += expression.slice(i, match.index);
        result += (_a = parameters[parameterName]) !== null && _a !== void 0 ? _a : '';
        i += ((_b = match.index) !== null && _b !== void 0 ? _b : 0) + match[0].length;
    }
    result += expression.slice(i);
    return result;
}
export function urlFromDescriptor(_a) {
    var { path, base, parameters } = _a, url = __rest(_a, ["path", "base", "parameters"]);
    if (path && parameters) {
        path = evaluatePath(path, parameters);
    }
    const baseURLComponents = parse(base ? String(base) : 'https://example.com');
    const urlString = serialize(Object.assign(Object.assign(Object.assign({}, baseURLComponents), url), { path }));
    return new URL(urlString, base);
}
export function requestFromDescriptor(requestDescriptor) {
    const { url, method, body } = requestDescriptor, init = __rest(requestDescriptor, ["url", "method", "body"]);
    const urlInit = url ? urlFromDescriptor(url) : '';
    if (!method || method.toUpperCase() === 'GET' || method.toUpperCase() === 'HEAD') {
        return new Request(urlInit, Object.assign({ method }, init));
    }
    else {
        return new Request(urlInit, Object.assign({ method, body }, init));
    }
}
export function reduceRequestDescriptor(descriptor, action) {
    switch (action.type) {
        case 'set':
            return action.value;
        case 'setPathParameter':
            return updateRequest(descriptor, { url: { parameters: { [action.name]: action.value } } });
        case 'setQueryParameter':
            const urlSearchParams = new URLSearchParams({ [action.name]: action.value });
            return updateRequest(descriptor, { url: { query: urlSearchParams.toString() } });
        case 'setHeader':
            const updatedHeaders = new Headers(descriptor.headers);
            updatedHeaders.set(action.name, action.value);
            return Object.assign(Object.assign({}, descriptor), { headers: updatedHeaders });
        case 'setBody':
            return Object.assign(Object.assign({}, descriptor), { body: action.body });
        default:
            const _ = action;
            invariant(false, `Invalid type: '${action.type}`);
    }
}
